import * as Common from '@/agiles/common';

export class EmailInfo extends Common.ObjectBase{
  constructor(){
    super('EmailInfo');  
  }
  public voucherNo:string = '';
  public counterpart: any = null;
  public mailAddress:string ='';
  public Subject:string = '';
  public Body:string = '';
  public isSend: boolean = false;
  public templateId: number = 0;
}

export class EmailInfoQuery extends Common.LoadQuery {
  constructor(modelName:string, items:any[], templateId:number, isMultipleReportSend?:boolean){
    super("EmailInfoQuery!" + modelName,EmailInfo);
    this.items = items;
    this.templateId = templateId;
    this.isMultipleReportSend = isMultipleReportSend;
  }
  public templateId: number;
  public items: any[] = null;
  public isMultipleReportSend: boolean = false;
}
